/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_Modal_Loading_Update_DescInputs */

const es_feedback_modal_loading_update_desc = /** @type {(inputs: Feedback_Modal_Loading_Update_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardando los cambios realizados.`)
};

const en_feedback_modal_loading_update_desc = /** @type {(inputs: Feedback_Modal_Loading_Update_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saving your changes.`)
};

/**
* | output |
* | --- |
* | "Saving your changes." |
*
* @param {Feedback_Modal_Loading_Update_DescInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const feedback_modal_loading_update_desc = /** @type {((inputs?: Feedback_Modal_Loading_Update_DescInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_Modal_Loading_Update_DescInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_feedback_modal_loading_update_desc(inputs)
	return en_feedback_modal_loading_update_desc(inputs)
});
export { feedback_modal_loading_update_desc as "feedback.modal.loading_update_desc" }